import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { fetchLoadPushData, fetchLoadPushDataCCTContractor, fetchLoadPushDataCCTLab, fetchLoadPushDataFormSGBuildex, fetchParticipantList } from "../services/loadsServices";
import useConnectionStore from "../store/useConnectors";

export const useLoadPushData = () => {
    const connectionId = useConnectionStore((s) => s.activeConnectionId);
    const queryClient = useQueryClient();
  
    return useMutation({
      mutationFn: (payload) => {
        return fetchLoadPushData(connectionId, payload);
      },
      // onSuccess: () => {
      //   // refresh extracttion list
      //   queryClient.invalidateQueries({ queryKey: ['extraction'] });
      // }
    });
  };


  export const useLoadPushDataSGBuildex = () => {
    const connectionId = useConnectionStore((s) => s.activeConnectionId);
    const queryClient = useQueryClient();
  
    return useMutation({
      mutationFn: (payload) => {
        return fetchLoadPushDataFormSGBuildex(connectionId, payload);
      },
      // onSuccess: () => {
      //   // refresh extracttion list
      //   queryClient.invalidateQueries({ queryKey: ['extraction'] });
      // }
    });
  };

  export const useLoadPushDataCCTLab = () => {
    const connectionId = useConnectionStore((s) => s.activeConnectionId);
    const queryClient = useQueryClient();
  
    return useMutation({
      mutationFn: (payload) => {
        return fetchLoadPushDataCCTLab(connectionId, payload);
      },
      // onSuccess: () => {
      //   // refresh extracttion list
      //   queryClient.invalidateQueries({ queryKey: ['extraction'] });
      // }
    });
  };

  export const useLoadPushDataCCTContractor = () => {
    const connectionId = useConnectionStore((s) => s.activeConnectionId);
    const queryClient = useQueryClient();
  
    return useMutation({
      mutationFn: (payload) => {
        return fetchLoadPushDataCCTContractor(connectionId, payload);
      },
      // onSuccess: () => {
      //   // refresh extracttion list
      //   queryClient.invalidateQueries({ queryKey: ['extraction'] });
      // }
    });
  };

  export const useGetParticipant = (element) => {
    const connectionId = useConnectionStore((s) => s.activeConnectionId);
    return useQuery({
      queryKey: ["participant", connectionId, element],
      queryFn: () => fetchParticipantList(connectionId, element),
      enabled: !!element,
    });
  }

